import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-secondry-button',
    templateUrl: './secondry-button.component.html',
    styleUrls: ['./secondry-button.component.scss'],
    standalone: false
})
export class SecondryButtonComponent {
  @Input() btnType: string;
  @Input() class: string;
  @Input() isImageClass: string;
  @Input() disabled: boolean;
  @Input() innerText:string;
  @Input() buttonIconBeforeTextPath:string
  @Input() buttonIconBeforeTextCss:string
  @Input() buttonIconAfterTextPath:string
  @Input() buttonIconAfterTextCss:string
  @Input() onlyImagePath:string
  @Input() isSvg:boolean
  @Input() isImage:boolean
  @Output() buttonClick: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();

  
  clickMethod() {
    this.buttonClick.emit(true);
  }

  changeMethod(){
    this.change.emit(true);
  }
}

